export default "__VITE_ASSET__d560fb6f__"